import { render } from "./verify-info-modal.vue?vue&type=template&id=1732120f&scoped=true"
import script from "./verify-info-modal.vue?vue&type=script&lang=js"
export * from "./verify-info-modal.vue?vue&type=script&lang=js"

import "./verify-info-modal.vue?vue&type=style&index=0&id=1732120f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1732120f"]])

export default __exports__